'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stylizr = require('@aftonbladet/stylizr');

var _stylizr2 = _interopRequireDefault(_stylizr);

var _rules = require('./rules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stylizrInstances = {};

exports.default = function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _rules.DEFAULT_HANDLERS;

    if (!stylizrInstances[key]) {
        stylizrInstances[key] = (0, _stylizr2.default)((0, _extends3.default)({}, handlers));
    }

    return stylizrInstances[key];
};
//# sourceMappingURL=getStylizrInstance.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-stylizr/lib/cjs/getStylizrInstance.js
 ** module id = 494
 ** module chunks = 1
 **/